import React from "react";

import Header from "../components/Header.js";
import Banner from "../components/Banner.js";

import "../styles/Home.css";
import Beneficios from "../components/Befeficios.js";
import SobreArc from "../components/SobreArc.js";
import Footer from "../components/Footer.js";
import ComoFunciona from "../components/ComoFunciona.js";
import Depoimentos from "../components/Depoimentos.js";
import Pricing from "../components/Pricing.js";

function Home() {
  return (
    <div className="pageHome">
      <Header />
      <Banner />
      <SobreArc />
      <ComoFunciona />
      <Beneficios />
      <Depoimentos />
      <Pricing />
      <Footer />
    </div>
  );
}

export default Home;
